import { environment } from '@mg-platform/core/core-util'

export const DASHBOARD_API_URL = {
  salesTrend: `${environment.apiUrl}/dashboard/sales-trend`,
  carsAvgTicketTiresTrend: `${environment.apiUrl}/dashboard/cars-avg-ticket-tires-trend`,
  benchmarkSales: `${environment.apiUrl}/dashboard/sales`,
  labor: `${environment.apiUrl}/dashboard/labor`,
  grossProfit: `${environment.apiUrl}/dashboard/gross-profit`,
  goals: `${environment.apiUrl}/dashboard/goals`,
  ranking: `${environment.apiUrl}/dashboard/ranking`,

  all: `${environment.apiUrl}/dashboard/all`
}
